<template>
    <!-- Navbar -->
    <nav class="navbar navbar-main navbar-expand-lg navbar-light navbar-position-stikcy header-shadow" navbar-scroll="false" style="height:3.45rem;">
      <div style="width:100%;">
        <div>      
          <div class="container-fluid py-0 px-3">
            
            <ul class="button toggle-side-bar d-sm-none d-md-none d-xl-block navbar-nav justify-content-end">
              <li class="nav-item d-flex align-items-center">
                <a href="#" class="nav-link text-body font-weight-bold ps-0 pe-3" style="margin-top:2px;">
                  <i v-show="false" class="fa fa-navicon mt-0" aria-hidden="true" style="font-size:20px;color:#6c757d;opacity:0.8;"></i>
                  <div v-show="true" class="sidenav-toggler-inner">
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                  </div>
                </a>
              </li>
            </ul>
            
            <nav aria-label="breadcrumb">
              <h6 class="font-weight-bolder mb-0">Dashboard</h6>
            </nav>
            
            <div class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
              <div class="ms-md-auto pe-md-3 d-flex align-items-center" v-show="false">
                <div class="input-group" style="display:none;">
                  <span class="input-group-text text-body"><i class="fas fa-search" aria-hidden="true"></i></span>
                  <input type="text" class="form-control" placeholder="Type here...">
                </div>
              </div>
              <ul class="navbar-nav  justify-content-end">
                <li class="nav-item d-flex align-items-center">
                  <el-dropdown trigger="click" @command="handleLogout">
                    <span class="el-dropdown-link capitalize">
                      <i class="el-icon-user-solid el-icon--left"></i>{{this.$store.getters.getUsername.replace('.',' ')}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item icon="el-icon-switch-button" command="logout">Logout&nbsp;&nbsp;</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <!--
                  <a href="#" class="nav-link text-body font-weight-bold px-0" v-on:click="openDropDownMenu">
                    <i class="fa fa-user me-sm-1 pe-1"></i>
                    <span class="d-sm-inline d-none">{{this.$store.getters.getUsername}}</span>
                  </a> -->
                </li>

                <!--
                <li class="nav-item dropdown d-flex align-items-center px-2">
                  <a href="#" class="p-0 nav-link text-body show" ref="dropdownMenuButton" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="cursor-pointer fa fa-angle-down" aria-hidden="true"></i>
                  </a>
                  <ul id="dropdownMenu" class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4 show" aria-labelledby="dropdownMenuButton">
                    
                    <li class="mb-0">
                      <a class="dropdown-item border-radius-md" href="javascript:;" v-on:click="openModal">
                        <div class="d-flex">
                          <div class="d-flex flex-column justify-content-center"><i class="fa fa-power-off pe-3" style="font-size:20px;"></i></div>
                          <div class="d-flex flex-column justify-content-center"><h4 class="mt-2 text-sm font-weight-normal">Logout</h4></div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </li>
                -->

                <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
                  <a href="javascript:;" class="nav-link text-body p-0" id="iconNavbarSidenav">
                    <div class="sidenav-toggler-inner">
                      <i class="sidenav-toggler-line"></i>
                      <i class="sidenav-toggler-line"></i>
                      <i class="sidenav-toggler-line"></i>
                    </div>
                  </a>
                </li>
              </ul>
            </div>

            <ConfirmModal v-show="isModalVisible" @close-modal="closeModal" @confirm-modal="logout" />
          </div>
        </div>

        <hr v-show="false" style="margin:6px 0px; padding:0px 0px; background:#a8abb2;"/>

        <div v-show="false">
          <div class="container-fluid px-3" style="padding-bottom:2px;padding-top:0px;">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-0 px-0 me-sm-6 me-5">
                <li class="breadcrumb-item text-sm"><a class="opacity-5 text-dark" href="javascript:;">Pages</a></li>
                <li class="breadcrumb-item text-sm text-dark active" aria-current="page">{{this.$store.state.page}}</li>
              </ol>         
            </nav>
          </div>
        </div>

      </div>   
    </nav>
    <!-- End Navbar -->

</template>

<style>
.navbar {
  /*box-shadow: 0 1px 10px 0 rgb(0 0 0 / 5%) !important; ORIGINAL*/
  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 0%) !important;
  border-bottom: 1px solid #EAEDF8;
}

aside li.nav-item .router-link, body.toggle-sidebar .sidenav .navbar-brand {
    padding: 1rem;
}


.capitalize {
    text-transform: capitalize;
}

body.toggle-sidebar .sidenav.fixed-left+.main-content, body.toggle-sidebar .g-sidenav-show .sidenav.fixed-left+.main-content {
  margin-left: 5rem; z-index: 44;
}

body.toggle-sidebar .navbar-vertical {
  max-width:5rem !important; z-index: 33; overflow: hidden; margin-left: 0px !important;
}

body.toggle-sidebar .nav-link-text,body.toggle-sidebar a.navbar-brand span {
  display: none; 
}

body.toggle-sidebar .navbar-vertical.navbar-expand-xs .navbar-nav .nav-link {
    margin: 0 ;
}

body.toggle-sidebar .navbar-vertical.navbar-expand-xs .navbar-nav .nav-link button {
  display: none;
}

body.toggle-sidebar .toggle-side-bar a.nav-link { z-index:99;}
body.toggle-sidebar aside .nav.collapse { 
  display: none; 
}

body.toggle-sidebar .navbar-vertical.navbar-expand-xs .navbar-nav .nav-link {
    margin: 0;
    padding-left: 15px;
    padding-right: 10px;
    width: 4rem; 
    max-width: 4rem;
    overflow: hidden;
}

body.toggle-sidebar .navbar-vertical.navbar-expand-xs:hover {
    /* max-width: 15.625rem !important; */
    max-width: 17.110rem !important;
}

body.toggle-sidebar .navbar-vertical.navbar-expand-xs:hover ul.navbar-nav .nav-link {
  width: 15.410rem !important; 
  max-width: 15.410rem !important;
  overflow: hidden;
}

body.toggle-sidebar .navbar-vertical.navbar-expand-xs:hover .nav-link-text {
    display: inline;
}

body.toggle-sidebar .navbar-vertical.navbar-expand-xs:hover .nav-link button {
    display: inline;
}

body.toggle-sidebar .navbar-vertical.navbar-expand-xs:hover a.navbar-brand span {
    display: inline;
}

body.toggle-sidebar .navbar-vertical.navbar-expand-xs:hover .nav.collapse {
    display: flex;
}


/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0px grey; 
  background: #F0F0F0;
  border-radius: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background-color: #ccc;
  /*background-image: linear-gradient(to top, #00d2ff 0%, #3a7bd5 100%);*/
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #A8A8A8; 
}

.navbar-position-stikcy {
	position: sticky !important;
	z-index: 30; /*1020*/
	left: auto;
	right: 0;
	top: 0%!important;
}

.header-shadow {
  box-shadow: 0 0.46875rem 2.1875rem rgb(4 9 20 / 3%), 0 0.9375rem 1.40625rem rgb(4 9 20 / 3%), 0 0.25rem 0.53125rem rgb(4 9 20 / 5%), 0 0.125rem 0.1875rem rgb(4 9 20 / 3%);
}

</style>
<script>

import {Config,AxiosWithJar} from '@/utility.js'
import ConfirmModal from '../components/modal/ConfirmModal.vue'

export default {
  components: {
    ConfirmModal,
  },
  data(){
   return {  
     isModalVisible: false,  
   }
 },  
  setup() {
    
  },
  mounted() {
    document.querySelector('.toggle-side-bar a.nav-link').addEventListener('click',function(e){      
      document.querySelector('body').classList.toggle('toggle-sidebar')      
      e.stopPropagation
    });

    /*
    const dropdownMenuButton = this.$refs.dropdownMenuButton;
    setTimeout(function() {
      dropdownMenuButton.click();
    }.bind(this),10); */

  },
  methods: {
    openDropDownMenu() {
      /*
      let dropdownMenuButton = document.getElementById("dropdownMenu").classList;
      if (dropdownMenuButton.contains("show")) {
        dropdownMenuButton.remove("show");
      } else {
        dropdownMenuButton.add("show");
      }
      */
    },
    logout() {
      this.closeModal();
      localStorage.removeItem('username');
      localStorage.removeItem('token');
      let baseurl = window.location.origin;
      //let loginurl = Config().webSSO;

      //let logouturl = 'https://sso.pertaminaretail.com/user/dologout?app=Dashboard&returl='+baseurl;
      //window.location.href = logouturl;

      window.location.href = '/login';
    },
    handleLogout() {
      console.log('logout');
        this.$confirm('Are you sure you would like to logout ?', 'Logout', {
          confirmButtonText: 'Logout',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Logout Confirmed !'
          });
          this.logout();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Logout canceled'
          });          
        });
      },
    openModal() { 
      this.isModalVisible = true;
    }, 
    closeModal() {
      this.isModalVisible = false;
    }, 
  }
}
</script>
